export default "__VITE_ASSET__DszD2fEM__"